/**
 * Public web origin used for Google OAuth `redirect_uri` and auth callback URLs.
 * - Set `REACT_APP_BASE_URL` to override (e.g. staging URL).
 * - In development, defaults to `window.location.origin` so localhost and any dev port stay on your machine.
 * - Add matching `http://localhost:<port>/auth/callback` in Google Cloud Console → OAuth client → Redirect URIs.
 */
function resolveBaseUrl(): string {
  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin;
    }
    return "http://localhost:3000";
  }
  return "https://dev.dealershub.ca";
}

export const AppConfig = {
  env: process.env.NODE_ENV,
  baseUrl: resolveBaseUrl(),
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL || "https://app.dev.dealershub.ca",
  googleClientId:
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "719472642934-mhv00veu14951sv47t53d2b5n9mo1ccq.apps.googleusercontent.com",
};
